<template>
  <List class="px-3" finished-text="没有更多了">
    <div
      @click="enterPlace(activity)"
      class="flex flex-col mb-3 lightshadow rounded-xl"
    >
      <div class="img-wrapper" :style="{ backgroundImage: 'url(' + activity.banner + ')' }"></div>
      <!-- <div class="flex flex-row flex-no-wrap overflow-x-auto">
        <div class="w-full flex-shrink-0 mr-3">
          <img
            :src="activity.banner"
            class="w-full"
            style="height: 112px"
            alt=""
          />
        </div>
        <div
          v-for="good in activity.actGoodsList"
          :key="good.partGoodsId"
          class="flex flex-col mr-3 items-center mt-1"
        >
          <div
            style="height: 80px; width: 80px"
            class="rounded-md overflow-hidden"
          >
            <img :src="good.goodsImage" class="h-full w-full" alt="" />
          </div>
          <div class="flex flex-row justify-between items-center">
            <div>
              <span class="text-xs">¥</span
              ><span class="text-base font-semibold">{{ good.actPrice }}</span>
            </div>
            <span class="text-red" style="white-space: nowrap"
              ><span class="text-xxs">省赚¥</span
              ><span class="text-xxs">{{ good.saveProfit }}</span></span
            >
          </div>
        </div>
        <div
          class="
            flex-shrink-0
            mr-3
            rounded-md
            flex flex-col
            items-center
            justify-center
            font-semibold
            mt-1
          "
          style="background-color: #d8d8d8; height: 80px; width: 80px"
        >
          <div class="-mb-1">查看</div>
          <div class="-mt-1">更多</div>
        </div>
      </div> -->
      <div
        class="flex flex-row items-end justify-between mr-2 text-xs px-2 pt-2"
      >
        <span
          ><div
            v-show="activity.state === 'IN_PROGRESS'"
            style="
              width: 36px;
              height: 20px;
              line-height: 20px;
              background: linear-gradient(135deg, #acf700 0%, #6edf0f 100%);
              border-radius: 5px;
            "
            class="text-xs inline-block text-center mr-1"
          >
            上新
          </div>
          <div
            v-show="activity.state === 'WARMING_UP'"
            style="
              width: 36px;
              height: 20px;
              line-height: 20px;
              background: linear-gradient(315deg, #ffb1b1 0%, #f70000 100%);
              border-radius: 5px;
            "
            class="text-xs inline-block text-center mr-1 text-white"
          >
            预告
          </div>
          <span class="font-semibold">{{ activity.actName }}</span></span
        ><Button
          v-distributor="true"
          style="padding-left: 8px; padding-right: 8px"
          round
          color="#E82035"
          size="mini"
          @click.stop="showDiag"
          >分享赚钱
          <img
            class="inline-block h-3"
            src="@/assets/brandplace/forward.svg"
            alt="" /></Button
        ><Button
          v-distributor="false"
          style="padding-left: 8px; padding-right: 8px"
          round
          color="#E82035"
          size="mini"
          @click.stop="enterPlace"
          >进入会场
          <!-- <img
            class="inline-block h-3"
            src="@/assets/brandplace/forward.svg"
            alt=""
        /> -->
        </Button>
      </div>
      <Overlay
        :show="diagVisible"
        @click="
          () => {
            diagVisible = false;
            showShare = false;
          }
        "
      >
        <div
          v-show="!showShare"
          class="wrapper mx-12"
          :class="showInput ? '-my-2' : 'my-12'"
          @click.stop
        >
          <div class="bg-white rounded-lg mb-6 overflow-auto p-3 text-left">
            <div class="flex items-center mb-2">
              <div style="height: 46px; width: 46px" class="flex-shrink-0 mr-3">
                <img
                  :src="forwardDetail.logoUrl"
                  class="h-full w-full rounded"
                  alt=""
                />
              </div>
              <div class="flex flex-col">
                <div class="text-xs font-semibold">
                  {{ forwardDetail.activityName }}
                </div>
                <div class="text-xs">{{ forwardDetail.brandName }}</div>
              </div>
            </div>
            <div class="flex justify-center">
              <div style="height: 182px; width: 182px" class="mr-1">
                <img
                  :src="forwardDetail.posterImg"
                  class="h-full w-full rounded"
                  alt=""
                />
              </div>
              <div class="flex flex-col justify-between">
                <img
                  style="height: 89px; width: 89px"
                  :src="forwardDetail.rightImgOne"
                  alt=""
                  class="rounded"
                />
                <img
                  style="height: 89px; width: 89px"
                  :src="forwardDetail.rightImgTwo"
                  alt=""
                  class="rounded"
                />
              </div>
            </div>
            <div class="text-xs py-1">
              {{ forwardDetail.goodsName }}
            </div>
            <div class="text-xs"></div>
            <div class="flex justify-between mb-3">
              <div class="text-red">
                <span class="text-xs">¥</span
                ><span class="font-semibold mr-2">{{
                  forwardDetail.price
                }}</span
                ><span class="text-xxs font-semibold"
                  >赚：{{ forwardDetail.saveProfit }}元</span
                >
              </div>
              <div class="text-xs">
                {{
                  dayjs(forwardDetail.activityTime).format(
                    "MM[月]DD[日] HH:mm"
                  )
                }}结束
              </div>
            </div>
            <!-- <div>
              <div class="text-xs">加价：</div>
              <div class="flex justify-between text-xs -mx-1 mb-2">
                <div
                  style="background-color: #f1f1f1"
                  class="h-8 leading-8 mx-1 flex-grow text-center rounded"
                  :class="{ activejiajia: jiajiaway === 1 }"
                  @click="() => (jiajiaway = 1)"
                >
                  不加价
                </div>
                <div
                  style="background-color: #f1f1f1"
                  class="h-8 leading-8 mx-1 flex-grow text-center rounded"
                  :class="{ activejiajia: jiajiaway === 2 }"
                  @click="() => (jiajiaway = 2)"
                >
                  加价10元
                </div>
                <div
                  style="background-color: #f1f1f1"
                  class="h-8 leading-8 mx-1 flex-grow text-center rounded"
                  :class="{ activejiajia: jiajiaway === 3 }"
                  @click="() => (jiajiaway = 3)"
                >
                  加价20%
                </div>
              </div>
              <div>
                <Field
                  class="rounded h-8 pt-1"
                  style="background-color: #f1f1f1"
                  placeholder="自定义金额"
                  input-align="center"
                  readonly
                  clickable
                  :value="customjiajia"
                  @touchstart.native.stop="
                    () => {
                      jiajiaway = 4;
                      showInput = true;
                    }
                  "
                />
              </div>
            </div> -->

            <NumberKeyboard
              v-model="customjiajia"
              :show="showInput"
              theme="custom"
              extra-key="."
              close-button-text="完成"
              @blur="showInput = false"
            />
          </div>
          <Button
            style="height: 2rem"
            round
            color="linear-gradient(135deg, #E82237 0%, #FF9D9D 100%)"
            size="large"
            v-gapclick="generatePost"
            >生成海报</Button
          >
        </div>
      </Overlay>

      <div
        class="flex flex-row justify-between flex-no-wrap items-center mr-2 p-2"
      >
        <div class="flex flex-row flex-no-wrap overflow-x-scroll h-5">
          <span
            v-for="services in activity.actServiceList"
            :key="services.id"
            class="text-xxs text-red border-red1px rounded px-1 mr-1"
            style="
              white-space: nowrap;
              padding-top: 0.1rem;
              padding-bottom: 0.1rem;
            "
            >{{ services.name }}</span
          >
        </div>
        <div class="text-left flex-shrink-0 flex items-end">
          <Countdown
            :startTime="activity.start"
            :endTime="activity.end"
            :padding="0"
          />
        </div>
      </div>
    </div>
  </List>
</template>

<script>
import {
  Button,
  List,
  Overlay,
  NumberKeyboard,
  Field,
  Image as VImage,
  Toast,
} from "vant";
import Countdown from "@/components/activity/Countdown";
import { getActList } from "../webApi";
import { priceMarkup, forwardDetail } from "@/api/forward.js";
export default {
  components: {
    Button,
    Countdown,
    List,
    Overlay,
    NumberKeyboard,
    // Field,
  },
  created() {
    getActList(this.$route.params.partId).then(({ data }) => {
      //不再是List了
      //不再是List了
      //不再是List了
      this.activity = data;
    });
  },
  data() {
    return {
      loading: false,
      finished: false,
      activity: {},
      forwardDetail: {},
      diagVisible: false,
      showInput: false,
      customjiajia: "",
      jiajiaway: 1,
      urlAddress: null,
      showShare: false,

      browserType: localStorage.getItem("browserType"),
    };
  },
  methods: {
    showDiag() {
      if (this.activity.isTheme) {
        this.$store.dispatch("app/showLoading");
        forwardDetail({
          actId: this.activity.actId,

          suitId: null,
          customerId: null,
          retailId: null,
          forwardType: "ACTIVITY",
        })
          .then(({ data }) => {
            this.$store.dispatch("app/hideLoading");
            this.forwardDetail = data;
            // this.diagVisible = true;
            this.generatePost();
          })
          .catch(() => this.$store.dispatch("app/hideLoading"));
      } else {
        Toast("暂无活动主题");
      }
    },
    enterPlace() {
      if (this.activity.isTheme) {
        this.$router.push({
          name: "ActivityPlace",
          params: { aid: this.activity.actId },
        });
      } else {
        Toast("暂无活动主题");
      }
    },

    generatePost() {
      let urlAddress;
      console.log(location);
      if (location.hostname === "localhost") {
        urlAddress =
          window.location.origin +
          "/activityPlace/" +
          this.activity.actId +
          "?customerId=" +
          this.$store.state.user.forwardId;
      } else {
        urlAddress =
          location.origin +
          "/activityPlace/" +
          this.activity.actId +
          "?customerId=" +
          this.$store.state.user.forwardId;
      }
      this.urlAddress = urlAddress;
      let params = {
        actId: this.activity.actId,

        retailId: null,
        markupType: "NONE",
        markupAmount: 0,
        markupRatio: 0,
        forwardType: "ACTIVITY",
        price: 0,
        urlAddress,
      };
      switch (this.jiajiaway) {
        case 1:
          params.markupType = "NONE";
          params.price = this.forwardDetail.price;
          break;
        case 2:
          params.markupType = "AMOUNT";
          params.markupAmount = 10;
          params.price = this.forwardDetail.price + 10;
          break;
        case 3:
          params.markupType = "RATIO";
          params.markupRatio = 0.2;
          params.price = this.forwardDetail.price * 1.2;
          break;
        case 4:
          if (!this.customjiajia) {
            return;
          }
          params.markupType = "AMOUNT";
          params.markupAmount = Number(this.customjiajia);
          params.price = this.forwardDetail.price + Number(this.customjiajia);

          break;
        default:
          break;
      }
      console.log(params);
      this.$store.dispatch("app/showLoading");
      priceMarkup(params).then(({ data }) => {
        this.$store.dispatch("app/hideLoading");
        // this.showShare = true;
        this.diagVisible = false;
        console.log(this.activity);
        this.$store.dispatch("sharePoster/show", {
          url: data.url,
          title: this.activity.actName,
          desc: this.activity.description,
          link: urlAddress,
          imgUrl: this.activity.actGoodsList[0]?.goodsImage,
        });
      }).catch(() => {
        this.$store.dispatch("app/hideLoading");
      })
    },
  },
};
</script>

<style lang="less" scoped>
.img-wrapper {
  width: 100%;
  height: 224px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>